import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "@helpers/i18n.js";

import Settings from "../settings.json";

Vue.use(VueRouter);

// services
// import AutoLogin from "./services/AutoLogin";

const routes = [
  {
    name: "app-start",
    path: "/",
    redirect: "/",
    component: () =>
      import(/* webpackChunkName: "app-start" */ "../layouts/default.vue"),
    children: [
      {
        name: "home",
        path: "",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(/* webpackChunkName: "home" */ "../views/Home.vue"),
      },
      {
        name: "admins",
        path: "admins",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin"],
        },
        component: () =>
          import(/* webpackChunkName: "admins" */ "../views/Admins.vue"),
      },
      {
        name: "batteries",
        path: "batteries",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(/* webpackChunkName: "batteries" */ "../views/Batteries.vue"),
      },
      {
        name: "new-batteries",
        path: "batteries/new-battery",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "batteries", path: { name: "batteries" } },
            {
              name: "new-batteries",
              path: { name: "new-batteries" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "new-battery" */ "../views/Batteries/NewBattery.vue"
          ),
      },
      {
        name: "batteries-detail",
        path: "batteries/:id",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "batteries", path: { name: "batteries" } },
            {
              name: "battery-detail",
              path: { name: "batteries-detail" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "battery-detail" */ "../views/Batteries/Detail.vue"
          ),
      },
      {
        name: "batteries-copy",
        path: "batteries/:id/copy",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "batteries", path: { name: "batteries" } },
            {
              name: "battery-copy",
              path: { name: "batteries-copy" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "battery-copy" */ "../views/Batteries/BatteryCopy.vue"
          ),
      },
      {
        name: "batteries-edit",
        path: "batteries/:id/edit",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "batteries", path: { name: "batteries" } },
            {
              name: "battery-edit",
              path: { name: "batteries-edit" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "battery-edit" */ "../views/Batteries/BatteryEdit.vue"
          ),
      },
      {
        name: "projects",
        path: "projects",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(/* webpackChunkName: "projects" */ "../views/Projects.vue"),
      },
      {
        name: "main-projects",
        path: "main-projects",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "main-projects" */ "../views/MainProjects.vue"
          ),
      },
      {
        name: "main-projects-id",
        path: "main-projects/:mainProjectId",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "main-projects", path: { name: "main-projects" } },
            {
              name: "main-projects-id",
              path: { name: "main-projects-id" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "main-projects-id" */ "../views/MainProjects/_mainProjectId.vue"
          ),
      },
      {
        name: "new-project",
        path: "new-project",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "projects", path: { name: "projects" } },
            {
              name: "new-project",
              path: { name: "new-project" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "new-projects" */ "../views/Projects/NewProject.vue"
          ),
      },
      {
        name: "project-copy",
        path: "projects/:projectId/copy",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "projects", path: { name: "projects" } },
            {
              name: "project-copy",
              path: { name: "project-copy" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "project-copy" */ "../views/Projects/ProjectCopy.vue"
          ),
      },
      {
        name: "project-edit",
        path: "projects/:projectId/edit",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "projects", path: { name: "projects" } },
            {
              name: "project-edit",
              path: { name: "project-edit" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "project-copy" */ "../views/Projects/ProjectEdit.vue"
          ),
      },
      {
        name: "project-detail",
        path: "projects/:projectId",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "projects", path: { name: "projects" } },
            {
              name: "project-detail",
              path: { name: "project-detail" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "project-copy" */ "../views/Projects/Detail.vue"
          ),
      },
      {
        name: "new-cycle",
        path: "cycles/new-cycle",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "cycles", path: { name: "cycles" } },
            {
              name: "new-cycle",
              path: { name: "new-cycle" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "new-cycles" */ "../views/Cycles/NewCycle.vue"
          ),
      },
      {
        name: "cycle-copy",
        path: "cycles/:cycleId/copy",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "cycles", path: { name: "cycles" } },
            {
              name: "cycle-copy",
              path: { name: "cycle-copy" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "cycle-copy" */ "../views/Cycles/CycleCopy.vue"
          ),
      },
      {
        name: "cycle-edit",
        path: "cycles/:cycleId/edit",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "cycles", path: { name: "cycles" } },
            {
              name: "cycle-edit",
              path: { name: "cycle-edit" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "cycle-copy" */ "../views/Cycles/CycleEdit.vue"
          ),
      },
      {
        name: "cycles-selection",
        path: "cycles/selection",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "cycles", path: { name: "cycles" } },
            {
              name: "cycles-selection",
              path: { name: "cycles-selection" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "cycles-selection" */ "../views/Cycles/CycleSelection.vue"
          ),
      },
      {
        name: "cycle-detail",
        path: "cycles/:cycleId",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "cycles", path: { name: "cycles" } },
            {
              name: "cycle-detail",
              path: { name: "cycle-detail" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "project-copy" */ "../views/Cycles/Detail.vue"
          ),
      },
      {
        name: "cycles",
        path: "cycles",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(/* webpackChunkName: "cycles" */ "../views/Cycles.vue"),
      },
      {
        name: "series",
        path: "series",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin"],
        },
        component: () =>
          import(/* webpackChunkName: "series" */ "../views/Series.vue"),
      },
      {
        name: "cycle-parameters",
        path: "settings/cycle-parameters",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "cycle-parameters" */ "../views/Settings/CycleParameters.vue"
          ),
      },
      {
        name: "departments",
        path: "departments",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "departments" */ "../views/Departments/index.vue"
          ),
      },
      {
        name: "department-detail",
        path: "departments/:departmentId",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "department-detail" */ "../views/Departments/DepartmentDetail/_departmentId.vue"
          ),
      },
      {
        name: "department-user-detail",
        path: "departments/:departmentId/users/:userId",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "DepartmentRoleAdmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "department-user-detail" */ "../views/Departments/DepartmentDetail/Users/_userId.vue"
          ),
      },
      {
        name: "my-department",
        path: "my-department",
        meta: {
          layout: "default",
          auth: true,
          roles: ["User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "my-department" */ "../views/MyDepartment.vue"
          ),
      },
      {
        name: "file-manager",
        path: "file-manager",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "file-manager" */ "../views/FileManager.vue"
          ),
      },
      {
        name: "vinc-calculating",
        path: "vinc-calculating",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "vinc-calculating" */ "../views/Calculatings/VincCalculating/index.vue"
          ),
      },
      {
        name: "vinc-calculating-list",
        path: "vinc-calculating-list",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "vinc-calculating-list" */ "../views/Calculatings/VincCalculating/List.vue"
          ),
      },
      {
        name: "vinc-calculating-detail",
        path: "vinc-calculating/:id",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "vinc-calculating-detail" */ "../views/Calculatings/VincCalculating/Detail.vue"
          ),
      },
      {
        name: "vinc-calculating-export-pdf",
        path: "vinc-calculating/:id/export-pdf",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "vinc-calculating-export-pdf" */ "../views/Calculatings/VincCalculating/ExportPdf.vue"
          ),
      },
      {
        name: "ehouse-calculating",
        path: "ehouse-calculating",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "ehouse-calculating" */ "../views/Calculatings/EhouseCalculating/index.vue"
          ),
      },
      {
        name: "ehouse-calculating-detail",
        path: "ehouse-calculating/:id",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "ehouse-calculating-detail" */ "../views/Calculatings/EhouseCalculating/Detail.vue"
          ),
      },
      {
        name: "ehouse-calculating-list",
        path: "ehouse-calculating-list",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "ehouse-calculating-list" */ "../views/Calculatings/EhouseCalculating/List.vue"
          ),
      },
      {
        name: "ehouse-double-calculating",
        path: "ehouse-double-calculating",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "ehouse-double-calculating" */ "../views/Calculatings/EhouseDoubleCalculating/index.vue"
          ),
      },
      {
        name: "ehouse-double-calculating-detail",
        path: "ehouse-double-calculating/:id",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "ehouse-double-calculating-detail" */ "../views/Calculatings/EhouseDoubleCalculating/Detail.vue"
          ),
      },
      {
        name: "ehouse-double-calculating-list",
        path: "ehouse-double-calculating-list",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "ehouse-double-calculating-list" */ "../views/Calculatings/EhouseDoubleCalculating/List.vue"
          ),
      },
      {
        name: "tks-calculating",
        path: "tks-calculating",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "tks-calculating" */ "../views/Calculatings/TksCalculating/index.vue"
          ),
      },
      {
        name: "tks-calculating-detail",
        path: "tks-calculating/:id",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "tks-calculating-detail" */ "../views/Calculatings/TksCalculating/Detail.vue"
          ),
      },
      {
        name: "tks-calculating-list",
        path: "tks-calculating-list",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "tks-calculating-list" */ "../views/Calculatings/TksCalculating/List.vue"
          ),
      },
      {
        name: "auxiliary-cooling-equipment",
        path: "auxiliary-cooling-equipment",
        meta: {
          layout: "default",
          auth: true,
          roles: ["Admin", "User"],
        },
        component: () =>
          import(
            /* webpackChunkName: "auxiliary-cooling-equipment" */ "../views/AuxiliaryCoolingEquipment/index.vue"
          ),
      },
    ],
  },
  {
    name: "account-start",
    path: "/account/",
    redirect: "/account/sign-in",
    /**
     * @description
     * The layout component for all account pages.
     *
     * This component is a shared layout for all pages under the account
/******  611e53d1-7f09-4d4d-b9df-39edb5d0639a  *******/
    component: () =>
      import(/* webpackChunkName: "account-start" */ "../layouts/account.vue"),
    children: [
      {
        name: "sign-in",
        path: "sign-in",
        meta: {
          layout: "account",
          auth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "account-sign-in" */ "../views/account/SignIn.vue"
          ),
      },
      {
        name: "sign-in-user",
        path: "sign-in/user",
        meta: {
          layout: "account",
          auth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "account-sign-in" */ "../views/account/SignIn.vue"
          ),
      },
      {
        name: "forget-password",
        path: "forget-password",
        meta: {
          layout: "account",
          auth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "account-forget-password" */ "../views/account/ForgetPassword.vue"
          ),
      },
      {
        name: "reset-password",
        path: "reset-password",
        meta: {
          layout: "account",
          auth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "account-reset-password" */ "../views/account/ResetPassword.vue"
          ),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
  mode: "hash",
});

router.beforeEach((to, from, next) => {
  document.title =
    i18n.t(`navigation.${to.name}`) + " | " + Settings.projectName;
  next();
});
export default router;
